import { createSelector } from "reselect";
import { adminSectionSelector } from "../../admin_section_selector";

export const adminRulesSelectedFacilityIdSelector = createSelector(
  adminSectionSelector,
  adminsSection => {
    return adminsSection.rulesTab.selectedOptions.facilityId;
  }
);
